import { autoinject, observable, bindable } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';
import * as Dto from '_models/dtos';
import { SessionData } from '_models/session-data';
import { UrlService } from '_services/url-service';
import { Dictionary } from '_services/dictionary';
import * as Rx from 'rxjs/Rx';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { SizeUtility } from '_controls/size-utility';

@autoinject
export class ColorSearch {
    private _sizeUtil: SizeUtility;
    private _http: HttpClient;
    private _url: UrlService;
    private _searchTextChangedEvent = new Rx.Subject();

    constructor(
        private _eventBus: EventAggregator,
        public sd: SessionData
    ) {
        this._sizeUtil = new SizeUtility();
        this._http = new HttpClient();
        this._url = new UrlService();

        // Throttle the calls to doSearch
        this._searchTextChangedEvent.debounceTime(400).subscribe(e => this.doSearch());
    }

    searchResults: Dto.ColorType[] = [];

    @observable colorSearchText: string;

    searchDialogWidth = '500px';

    attached() {
        this.searchDialogWidth = this.calculateDialogWidth();
        window.onresize = () => {
            this.searchDialogWidth = this.calculateDialogWidth();
        };
    }

    calculateDialogWidth() {
        return (this._sizeUtil.calculateWindowWidth() - 25).toString() + 'px';
    }

    colorsChanged(newVal, oldVal) {
        this.reset();
    }

    colorSearchTextChanged(newSearch: string, oldSearch: string) {
        this._searchTextChangedEvent.next();
        
    }

    doSearch() {
        if (this.colorSearchText.length == 0) {
            this.searchResults = [];
            return;
        }

        var url = this._url.build('~/api/Colors/SearchColors');
        var req = { productNumber: this.sd.wizard.selectedProduct.productNumber, searchText: this.colorSearchText };
        this._http.post(url, req).then(resp => {
            this.searchResults = resp.content;
            this.syncSearchResultsWithSelectedColors();
        });
    }

    isColorSearchFocused = false;

    isColorSearchOpen = false;
    colorSearchToggled() {
        this.isColorSearchOpen = !this.isColorSearchOpen;
        this.isColorSearchFocused = this.isColorSearchOpen;

        if (this.isColorSearchOpen) {
            this.syncSearchResultsWithSelectedColors();
        }
    }

    selectColor(color: Dto.ColorType) {
        this._eventBus.publish('color-search-selected', color);
    }

    syncSearchResultsWithSelectedColors() {
        this.searchResults.forEach(r => {
            
            var match = this.sd.wizard.selectedColors.find(s => s.colorUID == r.colorUID);
            if (match) {
                r.isSelected = true;
            } else
                r.isSelected = false;
        });
    }

    reset() {
        this.colorSearchText = '';
        this.searchResults = [];
    }
}